export let headerLinks = [
    {id:1, title:'STORE', pathName: "shop-store"},
    {id:2, title:'IPHONE', pathName: "shop-iphone"},
    {id:3, title:'IPAD', pathName: "shop-ipad"},
    {id:4, title:'MACBOOK', pathName: "shop-macbook"},
    {id:5, title:'ACCESORIES', pathName: "shop-accessories"},
]

export default headerLinks